import { Component, EventEmitter, Input, Output, AfterViewInit, ViewEncapsulation, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { Utils } from 'formiojs';
import { AddEditEventItem } from './add-edit-event-item/add-edit-event-item.component';
import { FormioLoader, FormioCustomComponent, ResourceNameService, ConfirmationDialogComponent } from 'dp-formio';

@Component({
    selector: 'app-event-tree-wrapper',
    templateUrl: './event-tree-wrapper.component.html',
    // styleUrls: ['./event-tree-wrapper.component.scss']
    encapsulation: ViewEncapsulation.None,
    providers: [FormioLoader]
})
export class EventTreeWrapperComponent implements FormioCustomComponent<any>, OnDestroy, OnChanges {
    dir: 'rtl' | 'ltr';
    @Input() required: boolean;
    @Input() value: any = {};
    @Output() valueChange = new EventEmitter<any>();
    @Input() disabled: boolean;
    @Input() viewOnly: boolean;
    @Input() data: any;
    @Input() customOptions: any;
    @Input() formioComponent: any;
    private subs: Subscription[] = [];
    set sub(s: Subscription) { this.subs.push(s); }

    events = [];

    constructor(private translateService: TranslateService,
        private resourceNameService: ResourceNameService,
        private formioLoader: FormioLoader,
        private dialog: MatDialog) {
        this.changeDirection(this.translateService.currentLang);
        this.sub = this.translateService.onLangChange.subscribe(data => {
            this.changeDirection(data.lang);
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        if (this.customOptions) {
            if (this.value?.events?.length) {
                this.events = this.value.events;
            }
        }
    }


    notifyValue() {
        this.value = { events: this.events };
        this.valueChange.emit(this.value);
    }

    addEvent() {
        this.events.push([]);
        this.notifyValue();
    }

    deleteEvent(index) {
        this.showConfirmation(result => {
            if (result) {
                this.events.splice(index, 1);
                this.notifyValue();
            }
        });
    }

    addEventItem(eventIndex: number, eventItemIndex: number = -1, viewOnly: boolean = false) {
        let evaluated = '';
        if (this.customOptions.eventItemForm.data) {
            evaluated = Utils.evaluate(this.customOptions.eventItemForm.data, { submission: this.data });
        }
        let submission: any = evaluated || { data: {} };
        if (this.events[eventIndex] && eventItemIndex != -1) {
            submission.data = {
                ...submission.data,
                ...this.events[eventIndex][eventItemIndex]
            };
        }

        this.dialog.open(AddEditEventItem, {
            data: {
                formKey: this.customOptions.eventItemForm.key,
                viewOnly: viewOnly,
                submission: submission,
                dir: this.dir,
            },
            height: this.customOptions.eventItemForm.dialogHeight || null,
            width: this.customOptions.eventItemForm.dialogWidth || null,
            panelClass: 'custom-event-modal-component',
            disableClose: false,
        }).afterClosed()
            .pipe(filter(q => !!q))
            .subscribe(result => {
                if (eventItemIndex != -1) this.events[eventIndex][eventItemIndex] = result;
                else this.events[eventIndex].push(result);
                this.notifyValue();
            });
    }

    deleteEventItem(eventIndex: number, eventItemIndex: number) {
        this.showConfirmation((result) => {
            if (result) {
                this.events[eventIndex].splice(eventItemIndex, 1);
                this.notifyValue();
            }
        });
    }

    editEventItem(eventIndex: number, eventItemIndex: number) {
        this.addEventItem(eventIndex, eventItemIndex);
    }

    viewEventItem(eventIndex: number, eventItemIndex: number) {
        this.addEventItem(eventIndex, eventItemIndex, true);
    }

    private changeDirection(lang) {
        this.dir = null;
        setTimeout(() => { this.dir = lang === 'ar' ? 'rtl' : 'ltr'; });
    }
    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
        this.subs = [];
    }

    private showConfirmation(callback: (result: any) => void) {
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: 'Are you sure to delete this item',
                buttonText: {
                    ok: 'Confirm',
                    cancel: 'Cancel',
                }
            },
            width: "40vw",
            panelClass: 'confirmation-dialog',
        }).afterClosed().subscribe(result => {
            callback(result);
        });
    }

}
